module.exports = __webpack_public_path__ + "img/q4-b.88b1974d.jpg";